import { Stack, ImageFit, Image, DefaultEffects, StackItem, mergeStyleSets } from '@fluentui/react';
import React, { useEffect, useState } from 'react'
import { useBranding } from "../../hooks/useBranding";
import GraphApiService, {IConsentUrlRequest} from "../../services/GraphApi";
import Helper from "../../Helpers/Helper";

const contentStyles = mergeStyleSets({
    mainContainer: {
        backgroundColor: "#050a1e",
        alignItems: "center",
        display: 'flex',
        flexDirection: 'column',
        flexShrink: 0,
        minHeight: '100%'
    },
    footer: {
        color: '#ffffff',
        width: '100vw',
        justifyContent: 'center',
        textAlign: 'center',
        backgroundColor: '#333333'
    },
    link: {
        color: '#478ac9'
    },
    message: {
        width: '50rem'
    }
})
function Consent() {
    const { branding, getAppSettings } = useBranding()
    const [message, setMessage] = useState("Loading...")

    useEffect(() => {
        getAppSettings()
        setTimeout(function () {
            var url_string = window.location.href
            var url = new URL(url_string);
            sendGraphApiConsent(url.searchParams)

        }, 1000);
    }, [])

    const sendGraphApiConsent = async (params: URLSearchParams) => {
        if (params.has('ClientId') && params.get('ClientId') !== "") {

            GraphApiService.ConsentUrl({
                Scope: params.get('Scope')!,
                State: params.get('State')!,
                ClientId: params.get('ClientId')!,
                RedirectUrl: params.get('RedirectURI')!,
            }).then((data) => {
                window.open(data.Url, '_self');
            }).catch((error) => {
                setMessage(error.message)
            })
        }
    }
    
    return (
        <div className={contentStyles.mainContainer}>
            <Stack className={contentStyles.message} grow={2}>
                <Stack tokens={{ padding: 32 }}>
                    <Image
                        src={branding.appLogo}
                        alt="Kim Technologies"
                        imageFit={ImageFit.contain}
                        height={64}
                    />
                </Stack>
                <Stack tokens={{ padding: 32 }}
                    styles={{
                        root: {
                            backgroundColor: "#FAFAFA",
                            borderRadius: "8px",
                            boxShadow: DefaultEffects.elevation16,

                        }
                    }}>
                    <Stack horizontal styles={{ root: { alignItems: "center" } }}>
                        <StackItem grow={1}>
                            <section className="u-align-center u-clearfix u-section-1" id="carousel_8db2">
                                <div className="u-align-left u-container-style u-expanded-width-lg u-expanded-width-md u-expanded-width-xl u-group u-image u-image-1" data-image-width="150" data-image-height="100">
                                    <div className="u-container-layout u-container-layout-1">
                                        <h2 className="u-subtitle u-text u-text-palette-1-dark-1 u-text-2">{message}</h2>
                                        <br />
                                        <div className="u-FlexInfoColumns-1">
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </StackItem>

                    </Stack>

                </Stack>

            </Stack>
            <Stack className={contentStyles.footer}>
                <footer id="sec-e947">
                    <div className="u-clearfix u-sheet u-sheet-1">
                        <p className="u-small-text u-text u-text-variant u-text-1">
                            {branding.appName} - Copyright {(new Date().getFullYear()).toString()}
                            <br />Kim Technologies <a href="https://www.ask.kim" className={contentStyles.link}>www.ask.kim</a>

                        </p>
                    </div>
                </footer>
            </Stack>
        </div>
    )
}

export default Consent